var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiRequestGateway } from "sb-authorization-lib";
// we don't cover external calls with tests
// for our tests we mock them based on their interfaces
/* istanbul ignore next */
export function getToken() {
    return __awaiter(this, void 0, void 0, function* () {
        return yield apiRequestGateway().getToken();
    });
}
// code available only in test runs is excluded from coverage
/* istanbul ignore next */
if (process.env.NODE_ENV === "test") {
    module.exports = {
        getToken: () => __awaiter(void 0, void 0, void 0, function* () { return Promise.resolve("__TOKEN__"); })
    };
}
//# sourceMappingURL=Auth.js.map